import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import OrderListEmployee from 'components/layout/order/OrderListEmployee';
import OrderListCustomer from 'components/layout/order/OrderListCustomer';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

import { ROLE_EMPLOYEE } from 'js/constants';
import may from 'js/security';

class Orders extends React.Component {
  render() {
    const {
      intl: { messages },
      user,
      types,
    } = this.props;

    return (
      <DocMeta tags={generateMetaTags(messages.meta.orders)}>
        {may(ROLE_EMPLOYEE, user.roles) ? <OrderListEmployee /> : <OrderListCustomer types={types} />}
      </DocMeta>
    );
  }
}
Orders.defaultProps = {
  types: ['car_rent', 'car_sales', 'item_sales'],
};

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(Orders));
